(function () {
  function syncScentTheme(root, pill) {
    if (!root || !pill) return;

    const handle = pill.dataset.scentHandle || '';
    const color = pill.dataset.scentColor || '';
    const onColor = pill.dataset.scentOnColor || '';

    root.classList.forEach((className) => {
      if (className.startsWith('is-scent-')) {
        root.classList.remove(className);
      }
    });

    if (handle) {
      root.classList.add('is-scent-' + handle);
    }

    if (color) {
      root.style.setProperty('--mm-gift-set-accent', color);
    }

    if (onColor) {
      root.style.setProperty('--mm-gift-set-accent-on', onColor);
    }
  }

  function getSelectedScentPill(root) {
    return root.querySelector('.mm-gift-set__scent input:checked')?.closest('.mm-gift-set__scent');
  }

  function syncScentPillSelection(root) {
    root.querySelectorAll('.mm-gift-set__scent').forEach((pill) => {
      const input = pill.querySelector('input[type="radio"]');
      const selected = Boolean(input?.checked);
      pill.classList.toggle('is-selected', selected);
      pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    syncScentTheme(root, getSelectedScentPill(root));
  }

  function updatePriceFromHtml(root, html) {
    if (!html) return;

    const priceEl = root.querySelector('[data-mm-price]');
    const saveEl = root.querySelector('[data-mm-save]');
    const newPrice = html.querySelector('[data-mm-price]');
    const newSave = html.querySelector('[data-mm-save]');

    if (priceEl && newPrice) {
      priceEl.textContent = newPrice.textContent;
    }

    if (saveEl && newSave) {
      saveEl.hidden = newSave.hidden;
      saveEl.textContent = newSave.textContent;
    }
  }

  function replaceFromHtml(root, selector, attr) {
    return function (html) {
      if (!html) return;
      const current = root.querySelector(selector);
      const next = html.querySelector(selector);
      if (!current || !next) return;

      const currentId = current.getAttribute(attr);
      const nextId = next.getAttribute(attr);
      if (currentId && nextId && currentId === nextId) return;

      current.replaceWith(next.cloneNode(true));
    };
  }

  function replaceGallery(root, html) {
    if (!html) return false;

    const current = root.querySelector('[data-mm-gift-set-gallery]');
    const next = html.querySelector('[data-mm-gift-set-gallery]');
    if (!current || !next) return false;

    const currentId = current.getAttribute('data-mm-gift-set-gallery-variant-id') || '';
    const nextId = next.getAttribute('data-mm-gift-set-gallery-variant-id') || '';
    if (currentId && nextId && currentId === nextId) return false;

    current.replaceWith(next.cloneNode(true));
    delete root.dataset.mmThumbsBound;
    initThumbs(root);
    return true;
  }

  function updateMainImageFromVariant(root, variant) {
    if (!variant?.featured_media?.preview_image?.src) return;

    const src = variant.featured_media.preview_image.src;
    root.querySelectorAll('.mm-gift-set__img').forEach((img) => {
      img.src = src;
      img.removeAttribute('srcset');
    });
  }

  function syncAddToCartButton(root, variant, html) {
    const button = root.querySelector('[ref="addToCartButton"], .mm-gift-set__atc');
    const textEl = root.querySelector('.mm-gift-set__atc-text');
    if (!button) return;

    const newButton = html?.querySelector?.('.mm-gift-set__atc');
    const newText = html?.querySelector?.('.mm-gift-set__atc-text');

    if (newButton && newText) {
      button.disabled = newButton.disabled;
      if (textEl) textEl.textContent = newText.textContent;
      return;
    }

    if (variant == null) {
      button.disabled = true;
      if (textEl) textEl.textContent = 'Unavailable';
      return;
    }

    button.disabled = !variant.available;
    if (textEl && !variant.available) {
      textEl.textContent = 'Sold out';
    }
  }

  function initThumbs(root) {
    if (root.dataset.mmThumbsBound === 'true') return;
    root.dataset.mmThumbsBound = 'true';

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-mm-thumb]');
      if (!thumb || !root.contains(thumb)) return;

      const full = thumb.getAttribute('data-full');
      const thumbs = root.querySelectorAll('[data-mm-thumb]');
      const mains = root.querySelectorAll('.mm-gift-set__img');

      thumbs.forEach((el) => {
        const on = el === thumb;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (!full || !mains.length) return;

      mains.forEach((img) => {
        img.src = full;
        const srcset = thumb.getAttribute('data-srcset');
        if (srcset) {
          img.srcset = srcset;
        } else {
          img.removeAttribute('srcset');
        }
      });
    });
  }

  function syncSellingPlan(root) {
    const planInput = root.querySelector('[data-mm-gift-set-selling-plan]');
    const subscription = root.querySelector('[data-mm-gift-set-subscription]');
    if (!planInput || !subscription) return;

    const mode = subscription.querySelector('[data-mm-gift-set-purchase-mode]:checked')?.value || 'onetime';
    const planId = subscription.dataset.defaultPlanId || '';

    subscription.querySelectorAll('.mm-gift-set__sub-option').forEach((option) => {
      const input = option.querySelector('input[type="radio"]');
      option.classList.toggle('is-selected', Boolean(input?.checked));
    });

    if (mode === 'subscribe' && planId) {
      planInput.value = planId;
      planInput.disabled = false;
      planInput.setAttribute('name', 'selling_plan');
    } else {
      planInput.value = '';
      planInput.disabled = true;
      planInput.removeAttribute('name');
    }
  }

  function initSubscription(root) {
    const subscription = root.querySelector('[data-mm-gift-set-subscription]');
    if (!subscription || subscription.dataset.mmSubBound === 'true') return;

    subscription.dataset.mmSubBound = 'true';
    subscription.querySelectorAll('[data-mm-gift-set-purchase-mode]').forEach((input) => {
      input.addEventListener('change', () => syncSellingPlan(root));
    });

    syncSellingPlan(root);
  }

  function handleVariantUpdate(event) {
    let root = event.target.closest('[data-mm-gift-set]');
    if (!root) {
      const picker = event.target.closest('variant-picker.mm-gift-set__variant-picker');
      const sectionId = picker?.dataset?.sectionId;
      if (sectionId) {
        root = document.querySelector('#shopify-section-' + sectionId + ' [data-mm-gift-set]');
      }
    }

    if (!root) return;

    const sectionProductId = root.dataset.productId;
    const eventProductId = event.detail?.data?.productId;
    if (sectionProductId && eventProductId && sectionProductId !== eventProductId) {
      return;
    }

    const html = event.detail?.data?.html;
    const variant = event.detail?.resource;

    if (html) {
      updatePriceFromHtml(root, html);
      replaceFromHtml(root, '[data-mm-gift-set-traits]', 'data-mm-gift-set-traits-variant-id')(html);
      replaceFromHtml(root, '[data-mm-gift-set-subscription]', 'data-default-plan-id')(html);
      if (!replaceGallery(root, html)) {
        updateMainImageFromVariant(root, variant);
      }
      syncAddToCartButton(root, variant, html);
    } else {
      updateMainImageFromVariant(root, variant);
      syncAddToCartButton(root, variant, null);
    }

    syncScentPillSelection(root);
    syncSellingPlan(root);
  }

  function boot(root) {
    if (!root) return;

    initThumbs(root);
    initSubscription(root);
    syncScentPillSelection(root);

    root.querySelectorAll('.mm-gift-set__scent input[type="radio"]').forEach((input) => {
      if (input.dataset.mmScentBound === 'true') return;
      input.dataset.mmScentBound = 'true';
      input.addEventListener('change', () => syncScentPillSelection(root));
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-mm-gift-set]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('variant:update', handleVariantUpdate);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-mm-gift-set]');
    if (!root) return;
    delete root.dataset.mmThumbsBound;
    root.querySelectorAll('[data-mm-scent-bound]').forEach((el) => {
      delete el.dataset.mmScentBound;
    });
    boot(root);
  });
})();
